import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchProducts } from '../../api/productsApi';
import { placeholderSvgDataUrl } from '../../utils/placeholderImage';

const RelatedProducts = ({ product }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const params = { active: true, limit: 5 };
        if (product?.category) params.category = product.category;
        const data = await fetchProducts(params);
        if (!mounted) return;
        const list = Array.isArray(data) ? data.filter((p) => p.id !== product.id) : [];
        setItems(list.length > 0 ? list.slice(0, 5) : []);
      } catch {
        if (mounted) setItems([]);
      }
    })();
    return () => { mounted = false; };
  }, [product?.id, product?.category]);

  if (items.length === 0) return null;

  return (
    <div className="mt-12">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-white">Related Products</h2>
        <Link to="/products" className="flex items-center gap-1 text-sm font-semibold text-brand transition-colors hover:text-white">
          View All
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><polyline points="12 5 19 12 12 19"/></svg>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3 lg:grid-cols-5">
        {items.map((p) => {
          const price = Number(p.price || 0);
          const mrp = Number(p.mrp || 0);
          const discount = mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;
          const img = (p.images && p.images[0]) || placeholderSvgDataUrl({ width: 400, height: 400, text: p.title || 'Product' });
          return (
            <Link
              key={p.id}
              to={`/product/${p.id}`}
              className="group overflow-hidden rounded-2xl border border-line bg-card transition-all duration-250 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-xl hover:shadow-black/40"
            >
              <div className="relative aspect-square overflow-hidden bg-white">
                <img src={img} alt={p.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
                {discount > 0 && (
                  <span className="absolute left-3 top-3 rounded-full bg-brand px-2.5 py-1 text-xs font-bold text-black">{discount}% OFF</span>
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-1 text-brand">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  ))}
                </div>
                <h3 className="mt-2 line-clamp-2 min-h-[40px] text-sm font-semibold text-white">{p.title}</h3>
                <div className="mt-2 flex items-center gap-2">
                  <span className="text-base font-bold text-brand">₹{price.toLocaleString()}</span>
                  {mrp > price && <span className="text-xs text-muted line-through">₹{mrp.toLocaleString()}</span>}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedProducts;
